import { AxiosError } from 'axios';
import { GET_DATA_ARCHIVAL_FILTER_YEAR_URL } from '../../constants/apiUrls';
import { GET_DATA_ARCHIVAL_FILTER_YEAR } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: string[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetDataArchivalFilterYear = ({ onError, onSuccess }: Input) => {
  const getDataArchivalFilterYear = async () => {
    const res = await axiosClient.get<string[]>(GET_DATA_ARCHIVAL_FILTER_YEAR_URL);

    return res.data;
  };

  return useCustomQuery([GET_DATA_ARCHIVAL_FILTER_YEAR], getDataArchivalFilterYear, {
    onSuccess,
    onError,
  });
};
